import styled from 'styled-components';

export const Form = styled.form`
background-color: ${({ theme }) => theme.colors.backgroundColor};
border-radius: 6px;
box-shadow: 0 0 5px 0 rgb(0 0 0 / 30%);
display: flex;
flex-direction: column;
justify-content: space-around;
padding: 24px 16px;
min-height: 214px;

input + .ant-select {
  margin-top: 16px;
}

select{
  :invalid{
    font-weight: 600;
    font-size: .85rem;
  }
}

.ant-select + .ant-select{
  margin-top: 16px;
}

.ant-input-number-input-wrap + .ant-select {
  margin-left: 8px;
}

div + input {
  margin-top: 16px;
}
`;

export const SubmitArea = styled.div`
align-items: center;
display: flex;
flex-direction: column;
justify-content: start;

span{
margin-top: 16px;
color: ${({ theme }) => theme.colors.error};
text-align: center;
}

button{
  margin-top: 24px;
}
`;
